// src/features/rrhh/mensajeria/components/MensajeCard.jsx
import { Stack, Typography } from "@mui/material";
import MailIcon from "@mui/icons-material/Mail";

export default function MensajeCard({ message, active, onClick }) {
  return (
    <Stack
      onClick={onClick}
      spacing={0.5}
      sx={{
        p: 1,
        borderRadius: "10px",
        cursor: "pointer",
        bgcolor: (t) => (active ? t.palette?.neutral?.[100] : t.palette?.neutral?.[50]),
        boxShadow: "inset 0px 0px 2px rgba(73, 73, 183, 0.45)",
        transition: "all .16s ease",
        "&:hover": {
          bgcolor: (t) => t.palette?.neutral?.[100],
        },
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <MailIcon sx={{ fontSize: 20, color: (t) => t.palette?.primary?.[900] }} />
        <Typography sx={{ fontSize: 14, fontWeight: 700, color: (t) => t.palette?.primary?.[900] }}>
          {message?.titulo || "Mensaje"}
        </Typography>
        <Typography sx={{ ml: "auto", fontSize: 12, opacity: 0.7 }}>
          {message?.fecha || ""}
        </Typography>
      </Stack>

      <Typography sx={{ fontSize: 12, color: (t) => t.palette?.primary?.[900], opacity: 0.9 }}>
        {message?.preview || ""}
      </Typography>

      <Stack direction="row" spacing={1} sx={{ opacity: 0.8, justifyContent: "flex-end" }}>
        <Typography sx={{ fontSize: 12 }}>
          Tema: <b>{message?.tema || "General"}</b>
        </Typography>
        <Typography sx={{ fontSize: 12 }}>
          Alcance: <b>{message?.alcance || "Todos"}</b>
        </Typography>
      </Stack>
    </Stack>
  );
}
